module.exports = __webpack_public_path__ + "static/media/Dashboard.5984429a.svg";